import StaticContentManagement from "./StaticContentManagement";

export default StaticContentManagement;
